import {Injectable} from '@angular/core';
import {UserCableRequirement} from '../../domain/infra/plug/plugType';
import {PlugOrientation} from '../../domain/infra/plug/plug';

@Injectable({
    providedIn: 'root'
})
export class FrontPlugBusinessService {
    constructor() { }

    computePlugOrientation(userCableRequirement: UserCableRequirement, hasPlugCable: boolean, handleUndefined?: boolean): PlugOrientation {
        let plugOrientation: PlugOrientation;

        if (userCableRequirement) {
            switch (userCableRequirement) {
                case UserCableRequirement.NONE:
                    plugOrientation = PlugOrientation.SOCKET_WITH_CABLE;
                    break;
                case UserCableRequirement.MAYBE:
                    if (hasPlugCable) {
                        // FIXME: use without cable for case when plugOrientation is undefined, fix by send plug's id
                        plugOrientation = handleUndefined ? PlugOrientation.SOCKET_WITHOUT_CABLE : undefined;
                    } else {
                        plugOrientation = PlugOrientation.SOCKET_WITH_CABLE;
                    }
                    break;
                case UserCableRequirement.REQUIRED:
                    plugOrientation = PlugOrientation.SOCKET_WITHOUT_CABLE;
                    break;
            }
        }

        return plugOrientation;
    }

    plugOrientationToString(plugOrientation: PlugOrientation): string {
        let plugOrientationAsString: string;

        switch (plugOrientation) {
            case PlugOrientation.SOCKET_WITH_CABLE:
                plugOrientationAsString = 'outlet';
                break;
            case PlugOrientation.SOCKET_WITHOUT_CABLE:
                plugOrientationAsString = 'socket';
                break;
        }

        return plugOrientationAsString;
    }
}
